(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.announcement-bar-countdown[data-end-time]').forEach(function (bar) {
      if (bar.dataset.countdownInit) return;
      bar.dataset.countdownInit = 'true';

      var timerEl = bar.querySelector('[data-timer-value]');
      var raw = bar.dataset.endTime;
      var endTime = raw ? new Date(raw) : null;
      if (!endTime || isNaN(endTime.getTime())) {
        endTime = new Date(Date.now() + 24 * 60 * 60 * 1000);
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        if (!timerEl) return;
        var diff = Math.max(0, endTime - new Date());
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        timerEl.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
        if (diff <= 0) {
          clearInterval(intervalId);
          bar.style.display = 'none';
        }
      }

      tick();
      var intervalId = setInterval(tick, 1000);

      var mobileTexts = bar.querySelectorAll('.announcement-bar-countdown__mobile-text');
      if (mobileTexts.length > 1) {
        var idx = 0;
        setInterval(function () {
          mobileTexts[idx].classList.remove('is-active');
          idx = (idx + 1) % mobileTexts.length;
          mobileTexts[idx].classList.add('is-active');
        }, 3000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('timer-announcement')) return;

    class TimerAnnouncement extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.end);
        if (isNaN(this.end.getTime())) {
          // Invalid date in settings: keep the bar, hide only the timer
          var t = this.querySelector('[data-timer]');
          if (t) t.hidden = true;
          return;
        }
        this.nums = {};
        var self = this;
        this.querySelectorAll('[data-num]').forEach(function (el) {
          self.nums[el.dataset.num] = el;
        });
        this.dayBox = this.querySelector('[data-box="d"]');
        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      set(key, value) {
        var el = this.nums[key];
        var text = this.pad(value);
        if (el && el.textContent !== text) el.textContent = text;
      }

      tick() {
        var diff = Math.max(0, this.end.getTime() - Date.now());
        var total = Math.floor(diff / 1000);
        var d = Math.floor(total / 86400);
        var h = Math.floor((total % 86400) / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;

        this.set('d', d);
        this.set('h', h);
        this.set('m', m);
        this.set('s', s);
        if (this.dayBox) this.dayBox.hidden = d === 0 && this.dataset.hideZeroDays === 'true';

        if (total <= 0) {
          clearInterval(this.timer);
          this.finish();
        }
      }

      finish() {
        var mode = this.dataset.expired;
        if (mode === 'keep') return; // keep showing 00 00 00
        if (mode === 'hide' && !(window.Shopify && window.Shopify.designMode)) {
          this.hidden = true;
          return;
        }
        var t = this.querySelector('[data-timer]');
        if (t) t.hidden = true;
        var divider = this.querySelector('.ann-timer__divider');
        var msg = this.querySelector('[data-expired-msg]');
        if (msg) {
          msg.hidden = false;
        } else if (divider) {
          divider.hidden = true;
        }
      }
    }

    customElements.define('timer-announcement', TimerAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luggage_customize"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ======================================================================
       Dependency-free canvas editor.

       Object geometry is normalised (0-1 of the print area), so a resize,
       orientation change or high-DPI screen never shifts a customer's
       artwork. Pixels are only computed at draw time.
       ====================================================================== */

    var CORNER = 7; // half-size of a corner handle, CSS px
    var GRAB = 18; // pointer tolerance for grabbing a handle
    var ROT_GAP = 30; // distance from the bottom edge to the rotate handle
    var ROT_R = 15; // rotate handle radius
    var MIN_PRINT_PX = 900; // below this an image is flagged low resolution
    var EXPORT_W = 2400; // long edge of the print-ready PNG

    var TITLES = { tools: 'Tools', text: 'Add Text', images: 'Upload your Images', layers: 'Layers', preview: 'Preview', summary: 'Preview' };

    class Eume extends HTMLElement {
      connectedCallback() {
        this.q = (s) => this.querySelector(s);
        this.qa = (s) => Array.prototype.slice.call(this.querySelectorAll(s));
        try {
          this.setup();
        } catch (err) {
          this.qa('[data-view]').forEach((v, i) => (v.hidden = i > 0));
          this.say('The customiser could not start. ' + err.message, true);
          if (window.console) console.error('[eume]', err);
        }
      }

      setup() {
        this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);

        this.objects = [];
        this.active = null;
        this.history = [];
        this.hIndex = -1;
        this.busy = false;
        this.presetTag = '';
        this.designTag = '';
        this.tab = 'text';

        this.canvas = this.q('[data-canvas]');
        this.ctx = this.canvas ? this.canvas.getContext('2d') : null;
        this.base = this.q('[data-base]');
        this.print = this.q('[data-print]');

        this.bindNav();
        this.bindPresets();
        this.bindColour();
        this.bindEditor();
        this.bindCanvas();
        this.bindModal();

        this.fonts = (this.cfg.fonts || []).map((f) => f.trim()).filter(Boolean);
        this.font = this.fonts[0] || 'sans-serif';
        var up = this.q('[data-upload-count]');
        if (up) up.textContent = 'Up to ' + (Number(this.cfg.maxImages) || 2) + ' images.';
        this.atcLabel = ((this.q('[data-preset-atc]') || {}).textContent || 'Add to Cart').trim();
        this.colourNextLabel = ((this.q('[data-colour-next]') || {}).textContent || 'Next').trim();
        this.updateStock();
        this.fonts.forEach((f) => this.loadFont(f));
        this.drawFonts('');
        this.paintAa();

        this.push();
        this.show('entry', true);

        var frame = this.q('[data-frame]');
        if (frame && window.ResizeObserver) {
          this.ro = new ResizeObserver(() => this.layout());
          this.ro.observe(frame);
        }
        window.addEventListener('resize', () => this.layout());
      }

      /* Bind defensively: Shopify serves the section's JS as a cached asset
         while the HTML renders fresh, so the two can disagree after an edit. A
         missing element must not take the whole customiser down. */
      on(sel, ev, fn) {
        var el = this.q(sel);
        if (!el) {
          if (window.console) console.warn('[eume] no element for', sel);
          return null;
        }
        el.addEventListener(ev, fn);
        return el;
      }

      set(sel, prop, value) {
        var el = this.q(sel);
        if (el) el[prop] = value;
        return el;
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
      }

      /* ------------------------------------------------------------ routing */

      bindNav() {
        this.qa('[data-go]').forEach((b) =>
          b.addEventListener('click', () => {
            var t = b.dataset.go;
            if (t === 'exit') return window.history.back();
            if (!this.cfg.product) return this.say('No product is set up yet.', true);
            if (t === 'presets' && !this.cfg.presets.length) return this.say('No premade designs have been uploaded yet.', true);
            if (t === 'colour' && !this.cfg.showColourStep) t = 'editor';
            if (t === 'editor' && !this.productVariant()) {
              return this.say(this.cfg.soldOutLabel || 'Sold out', true);
            }
            this.show(t);
          })
        );
      }

      show(view, quiet) {
        this.view = view;
        this.qa('[data-view]').forEach((v) => (v.hidden = v.dataset.view !== view));
        if (view === 'editor') {
          requestAnimationFrame(() => this.layout());
          this.setTab('text', true);
        }
        if (!quiet && this.scrollIntoView) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      /* ------------------------------------------------------------ presets */

      bindPresets() {
        var designs = this.cfg.presets || [];
        if (!this.cfg.product || !designs.length) {
          this.set('[data-preset-setup]', 'hidden', false);
          this.set('[data-preset-box]', 'hidden', true);
          this.set('[data-preset-atc]', 'hidden', true);
          return;
        }
        this.presetIndex = 0;

        var tiles = this.q('[data-preset-tiles]');
        var dots = this.q('[data-preset-dots]');
        designs.forEach((d, i) => {
          if (tiles) tiles.appendChild(this.designTile(d, i));
          if (!dots) return;
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', d.name);
          dot.addEventListener('click', () => this.setPreset(i));
          dots.appendChild(dot);
        });

        var step = (n) => this.setPreset((this.presetIndex + n + designs.length) % designs.length);
        this.on('[data-preset-prev]', 'click', () => step(-1));
        this.on('[data-preset-next]', 'click', () => step(1));

        var field = this.q('[data-preset-field]') || document.createElement('input');
        var save = this.q('[data-preset-save]') || document.createElement('button');

        this.on('[data-preset-toggle]', 'change', (e) => {
          if (e.target.checked) this.openEngraving('preset');
          else this.clearTag('preset');
        });
        this.on('[data-preset-edit]', 'click', () => this.openEngraving('preset'));
        this.on('[data-preset-remove]', 'click', () => this.clearTag('preset'));
        field.addEventListener('input', () => {
          this.set('[data-preset-count]', 'textContent', field.value.length + '/' + this.cfg.engraving.max);
          save.disabled = !field.value.trim();
        });
        save.addEventListener('click', () => this.saveTag('preset', field.value));
        this.on('[data-preset-cancel]', 'click', () => this.closeInline('preset'));
        this.on('[data-preset-atc]', 'click', () => this.addPreset());

        this.setPreset(0);
      }

      designTile(d, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'eume-tile';
        b.innerHTML = '<img src="' + d.image + '" alt="" loading="lazy"><b>' + esc(d.name) + '</b><small>' + this.money(this.productPrice()) + '</small>';
        b.addEventListener('click', () => this.setPreset(i));
        return b;
      }

      /* Both journeys share one product. Only an in-stock variant may be sold;
         a separate lookup is used for showing a price so a sold-out product
         still displays sensibly instead of rendering zero. */
      productVariant() {
        var vs = (this.cfg.product && this.cfg.product.variants) || [];
        return vs.filter((v) => v.available)[0] || null;
      }

      displayVariant() {
        var vs = (this.cfg.product && this.cfg.product.variants) || [];
        return this.productVariant() || vs[0] || null;
      }

      productPrice() {
        var v = this.displayVariant();
        return v ? v.price : 0;
      }

      /* Reflect stock in every buy button. Called after setup and whenever the
         selected variant or the confirmation checkbox changes. */
      updateStock() {
        var soldOut = this.cfg.soldOutLabel || 'Sold out';
        var canBuyPreset = !!this.productVariant();
        var presetBtn = this.q('[data-preset-atc]');
        if (presetBtn && !this.busy) {
          presetBtn.disabled = !canBuyPreset;
          presetBtn.textContent = canBuyPreset ? this.atcLabel : soldOut;
        }

        // Nothing sellable means there is no point entering the designer.
        var anyStock = !!this.productVariant();
        var nextBtn = this.q('[data-colour-next]');
        if (nextBtn) {
          nextBtn.disabled = !anyStock;
          nextBtn.textContent = anyStock ? this.colourNextLabel : soldOut;
        }

        var bodyOk = !!(this.body && this.body.available);
        var confirmed = !!(this.q('[data-confirm]') || {}).checked;
        var designBtn = this.q('[data-design-atc]');
        if (designBtn && !this.busy) {
          designBtn.disabled = !bodyOk || !confirmed;
          designBtn.textContent = bodyOk ? this.atcLabel : soldOut;
        }
      }

      tile(v, onClick) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'eume-tile';
        b.disabled = !v.available;
        b.innerHTML = '<img src="' + v.image + '" alt="" loading="lazy"><b>' + esc(v.title) + '</b><small>' + this.money(v.price) + '</small>';
        b.addEventListener('click', onClick);
        return b;
      }

      setPreset(i) {
        var designs = this.cfg.presets || [];
        var d = designs[i];
        if (!d) return;
        this.presetIndex = i;
        var img = this.q('[data-preset-image]');
        if (img) {
          img.src = d.image;
          img.alt = this.cfg.product.title + ' - ' + d.name;
        }
        this.set('[data-preset-title]', 'textContent', d.name);
        this.set('[data-preset-price]', 'textContent', this.money(this.productPrice()));
        this.qa('[data-preset-tiles] .eume-tile').forEach((b, n) => b.setAttribute('aria-pressed', String(n === i)));
        this.qa('[data-preset-dots] button').forEach((b, n) => b.setAttribute('aria-current', String(n === i)));
      }

      async addPreset() {
        if (this.busy) return;
        var btn = this.q('[data-preset-atc]');
        this.busy = true;
        btn.disabled = true;
        this.say('Adding to cart\u2026');
        try {
          var variant = this.productVariant();
          if (!variant) throw new Error('This product is out of stock.');
          var design = (this.cfg.presets || [])[this.presetIndex];

          var props = {};
          if (design) {
            props[this.cfg.designProperty] = design.name;
            // The CDN URL is enough for production to pull the artwork, and it
            // keeps the whole add as one atomic JSON call.
            props[this.cfg.designImageProperty] = design.file || design.image;
          }

          var items = [{ id: variant.id, quantity: 1, properties: props }];

          if (this.presetTag) {
            var key = Date.now() + '_' + variant.id;
            props[this.cfg.engraving.property] = this.presetTag;
            props._Personalisation = 'Yes';
            props._BundleKey = key;
            if (this.cfg.engraving.freebieId) {
              var fb = { _Freebie: 'Yes', _BundleKey: key };
              fb[this.cfg.engraving.property] = this.presetTag;
              items.push({ id: Number(this.cfg.engraving.freebieId), quantity: 1, properties: fb });
            }
          }

          await this.cartAdd(items);
          window.location.href = this.cfg.cartUrl;
        } catch (err) {
          this.say(err.message, true);
          btn.disabled = false;
        } finally {
          this.busy = false;
        }
      }

      /* ------------------------------------------- engraving, both journeys */

      isDesktop() {
        return window.matchMedia('(min-width: 990px)').matches;
      }

      openEngraving(which) {
        if (this.isDesktop() || !this.modal) {
          this.set('[data-' + which + '-inline]', 'hidden', false);
          this.set('[data-' + which + '-saved]', 'hidden', true);
          this.set('[data-' + which + '-togglerow]', 'hidden', false);
          if (which === 'preset') {
            this.set('[data-preset-inlineactions]', 'hidden', false);
            this.set('[data-preset-boxlabel]', 'textContent', this.presetLabelPlain);
            this.set('[data-preset-atc]', 'disabled', true);
          }
          this.q('[data-' + which + '-field]').focus();
        } else {
          this.modalFor = which;
          if (this.mField) {
            this.mField.value = which === 'preset' ? this.presetTag : this.designTag;
            this.mField.focus();
          }
          this.modal.hidden = false;
        }
      }

      closeInline(which) {
        this.set('[data-' + which + '-inline]', 'hidden', true);
        if (which === 'preset') {
          this.set('[data-preset-inlineactions]', 'hidden', true);
          this.set('[data-preset-atc]', 'disabled', false);
        }
        if (!this[which + 'Tag']) this.clearTag(which);
        else this.set('[data-' + which + '-saved]', 'hidden', false);
      }

      saveTag(which, raw) {
        var value = String(raw || '').trim().slice(0, this.cfg.engraving.max);
        if (!value) return;
        this[which + 'Tag'] = value;
        this.set('[data-' + which + '-savedvalue]', 'textContent', 'Added: ' + value);
        this.set('[data-' + which + '-saved]', 'hidden', false);
        this.set('[data-' + which + '-togglerow]', 'hidden', true);
        this.set('[data-' + which + '-inline]', 'hidden', true);
        if (which === 'preset') {
          this.set('[data-preset-inlineactions]', 'hidden', true);
          this.set('[data-preset-boxlabel]', 'textContent', this.presetLabel);
          this.set('[data-preset-atc]', 'disabled', false);
        }
        if (this.modal) this.modal.hidden = true;
        if (which === 'design') this.summary();
      }

      clearTag(which) {
        this[which + 'Tag'] = '';
        this.set('[data-' + which + '-toggle]', 'checked', false);
        this.set('[data-' + which + '-togglerow]', 'hidden', false);
        this.set('[data-' + which + '-saved]', 'hidden', true);
        this.set('[data-' + which + '-inline]', 'hidden', true);
        var f = this.q('[data-' + which + '-field]');
        if (f) f.value = '';
        var c = this.q('[data-' + which + '-count]');
        if (c) c.textContent = '0/' + this.cfg.engraving.max;
        if (which === 'preset') {
          this.set('[data-preset-inlineactions]', 'hidden', true);
          this.set('[data-preset-boxlabel]', 'textContent', this.presetLabel);
          this.set('[data-preset-atc]', 'disabled', false);
        } else {
          this.summary();
        }
      }

      bindModal() {
        this.modal = this.q('[data-modal]');
        this.mField = this.q('[data-modal-field]');
        this.presetLabel = this.q('[data-preset-boxlabel]') ? this.q('[data-preset-boxlabel]').textContent : '';
        this.presetLabelPlain = this.presetLabel.replace(/\s*\(.*\)\s*$/, '');

        this.on('[data-modal-save]', 'click', () => {
          if (!this.mField.value.trim()) return this.mField.focus();
          this.saveTag(this.modalFor, this.mField.value);
        });
        [this.q('[data-modal-cancel]'), this.q('[data-modal-close]')].filter(Boolean).forEach((b) =>
          b.addEventListener('click', () => {
            this.modal.hidden = true;
            if (!this[this.modalFor + 'Tag']) this.clearTag(this.modalFor);
          })
        );
        if (!this.modal) return;
        this.modal.addEventListener('click', (e) => {
          if (e.target !== this.modal) return;
          this.modal.hidden = true;
          if (!this[this.modalFor + 'Tag']) this.clearTag(this.modalFor);
        });
      }

      /* ------------------------------------------------------------- colour */

      bindColour() {
        var p = this.cfg.product;
        if (!p) {
          this.set('[data-colour-setup]', 'hidden', false);
          return;
        }
        this.body = p.variants.filter((v) => v.available)[0] || p.variants[0];
        var grid = this.q('[data-colour-tiles]');
        if (grid) p.variants.forEach((v) => grid.appendChild(this.tile(v, () => this.setBody(v))));
        // setBody refuses sold-out variants, so seed the first one directly.
        var seed = this.body;
        this.body = null;
        if (seed.available) this.setBody(seed);
        else {
          this.body = seed;
          this.set('[data-colour-preview]', 'src', seed.image);
          if (this.base) this.base.src = seed.image;
          this.refresh();
        }
      }

      setBody(v) {
        if (!v.available) return this.say(this.cfg.soldOutLabel || 'Sold out', true);
        if (this.objects.length && this.body && v.id !== this.body.id) {
          if (!window.confirm('Changing the body colour clears your design. Continue?')) return;
          this.objects = [];
          this.active = null;
          this.push();
        }
        this.body = v;
        this.set('[data-colour-preview]', 'src', v.image);
        if (this.base) {
          this.base.src = v.image;
          this.base.alt = this.cfg.product.title + ' - ' + v.title;
          this.base.addEventListener('load', () => {
            this.measureSubject();
            this.layout();
          }, { once: true });
          this.subject = null;
        }
        var i = this.cfg.product.variants.indexOf(v);
        this.qa('[data-colour-tiles] .eume-tile').forEach((b, n) => b.setAttribute('aria-pressed', String(n === i)));
        this.refresh();
      }

      /* -------------------------------------------------- canvas positioning */

      layout() {
        if (!this.ctx || !this.base || !this.print) return;
        if (!this.subject) this.measureSubject();
        var a = this.cfg.printArea;
        var box = this.base.getBoundingClientRect();
        if (!box.width || !this.base.naturalWidth) return;

        var ratio = this.base.naturalWidth / this.base.naturalHeight;
        var dw = box.width;
        var dh = box.width / ratio;
        if (dh > box.height) {
          dh = box.height;
          dw = box.height * ratio;
        }
        var ox = (box.width - dw) / 2;
        var oy = (box.height - dh) / 2;

        // Percentages are relative to the luggage, not the padded photo.
        var sub = this.subject || { x: 0, y: 0, w: 1, h: 1 };
        var subX = ox + dw * sub.x;
        var subY = oy + dh * sub.y;
        var subW = dw * sub.w;
        var subH = dh * sub.h;

        var w = Math.round((subW * a.width) / 100);
        var h = Math.round((subH * a.height) / 100);

        this.print.style.top = subY + (subH * a.top) / 100 + 'px';
        this.print.style.left = subX + (subW * a.left) / 100 + 'px';
        this.print.style.width = w + 'px';
        this.print.style.height = h + 'px';

        var dpr = Math.min(window.devicePixelRatio || 1, 3);
        this.canvas.width = Math.round(w * dpr);
        this.canvas.height = Math.round(h * dpr);
        this.canvas.style.width = w + 'px';
        this.canvas.style.height = h + 'px';
        this.W = w;
        this.H = h;
        this.dpr = dpr;
        var cap = this.maxTextSize();
        var floor = this.minTextSize();
        this.objects.forEach((o) => {
          if (o.type === 'image') {
            o.w = this.fitToFrame(o, o.w);
            return;
          }
          if (o.size > cap) o.size = cap;
          if (o.size < floor) o.size = floor;
          o.size = this.fitToFrame(o, o.size);
        });
        this.render();
      }

      /* ----------------------------------------------------------- geometry */

      /* Sample the product photo at low resolution and remember where the
         luggage actually sits inside it. Falls back to the whole frame if the
         canvas is tainted or the scan finds nothing. */
      measureSubject() {
        this.subject = { x: 0, y: 0, w: 1, h: 1 };
        var img = this.base;
        if (!this.cfg.autoFit || !img || !img.naturalWidth) return;
        this.subjectCache = this.subjectCache || {};
        if (this.subjectCache[img.src]) {
          this.subject = this.subjectCache[img.src];
          return;
        }
        try {
          var sw = 160;
          var sh = Math.max(1, Math.round((sw * img.naturalHeight) / img.naturalWidth));
          var off = document.createElement('canvas');
          off.width = sw;
          off.height = sh;
          var c = off.getContext('2d');
          c.drawImage(img, 0, 0, sw, sh);
          var box = subjectBox(c.getImageData(0, 0, sw, sh).data, sw, sh);
          if (box.w > 0.05 && box.h > 0.05) {
            this.subject = box;
            this.subjectCache[img.src] = box;
          }
        } catch (e) {
          if (window.console) console.warn('[eume] could not measure the product photo', e);
        }
      }

      /* Text sizing, normalised against the current frame width.
         New text starts partway up the range so the corner handles always have
         room to grow as well as shrink; starting it at the cap made resizing
         look broken. */
      /* The print frame is the only ceiling on text size. */
      maxTextSize() {
        return 10;
      }

      /* Largest value at which an element still fits inside the print frame.
         Width and height both scale linearly with the driving value (font size
         for text, normalised width for images), and so does the axis-aligned
         box of the rotated result, so one factor is exact rather than iterative. */
      fitToFrame(o, desired) {
        if (!this.W || !this.H) return desired;
        var w, h;
        if (o.type === 'image') {
          if (!o.natW || !o.natH) return desired;
          w = desired * this.W;
          h = (w * o.natH) / o.natW;
        } else {
          var m = this.size({ type: 'text', text: o.text, font: o.font, size: desired });
          w = m.w;
          h = m.h;
        }
        var cos = Math.abs(Math.cos(o.angle || 0));
        var sin = Math.abs(Math.sin(o.angle || 0));
        var boxW = w * cos + h * sin;
        var boxH = w * sin + h * cos;
        if (boxW <= 0 || boxH <= 0) return desired;
        return desired * Math.min(this.W / boxW, this.H / boxH, 1);
      }

      /* Start below the limit so the corner handles can grow as well as shrink. */
      startSizeFor(o) {
        var max = this.fitToFrame(o, o.type === 'image' ? 4 : 10);
        if (o.type === 'image') return Math.min(max, max * 0.6);
        return Math.min(this.maxTextSize(), max * 0.6);
      }

      minTextSize() {
        return 0.04;
      }

      /* Start at a fraction of whatever this particular string can reach, so the
         corner handles always have room to grow. A fixed starting size would sit
         at the frame limit for longer words and look frozen. */


      size(o) {
        if (o.type === 'image') {
          var w = o.w * this.W;
          return { w: w, h: (w * o.natH) / o.natW };
        }
        var px = o.size * this.W;
        var c = this.ctx;
        c.save();
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.font = '600 ' + px + 'px "' + o.font + '", sans-serif';
        var m = c.measureText(o.text || ' ');
        c.restore();
        return { w: Math.max(m.width, px * 0.3), h: px * 1.25, px: px };
      }

      toLocal(px, py, o) {
        var dx = px - o.x * this.W;
        var dy = py - o.y * this.H;
        var cos = Math.cos(-o.angle);
        var sin = Math.sin(-o.angle);
        return { x: dx * cos - dy * sin, y: dx * sin + dy * cos };
      }

      toWorld(lx, ly, o) {
        var cos = Math.cos(o.angle);
        var sin = Math.sin(o.angle);
        return { x: o.x * this.W + lx * cos - ly * sin, y: o.y * this.H + lx * sin + ly * cos };
      }

      corners(o) {
        var s = this.size(o);
        var self = this;
        return [
          [-s.w / 2, -s.h / 2],
          [s.w / 2, -s.h / 2],
          [s.w / 2, s.h / 2],
          [-s.w / 2, s.h / 2],
        ].map((p) => self.toWorld(p[0], p[1], o));
      }

      rotHandle(o) {
        var s = this.size(o);
        return this.toWorld(0, s.h / 2 + ROT_GAP, o);
      }

      /* ---------------------------------------------------------- rendering */

      render() {
        var c = this.ctx;
        if (!c || !this.W) return;
        c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
        c.clearRect(0, 0, this.W, this.H);
        this.paint(c, this.W, this.H);
        if (this.active) this.paintChrome(c);
        this.checkOutside();
      }

      paint(c, W, H) {
        this.objects.forEach((o) => {
          if (!o.visible) return;
          c.save();
          c.translate(o.x * W, o.y * H);
          c.rotate(o.angle);
          if (o.type === 'image') {
            if (o.img && o.img.complete && o.img.naturalWidth) {
              var w = o.w * W;
              var h = (w * o.natH) / o.natW;
              c.drawImage(o.img, -w / 2, -h / 2, w, h);
            }
          } else {
            var px = o.size * W;
            c.font = '600 ' + px + 'px "' + o.font + '", sans-serif';
            c.textAlign = 'center';
            c.textBaseline = 'middle';
            if (o.stroke && o.stroke.toLowerCase() !== o.fill.toLowerCase()) {
              c.lineWidth = Math.max(1, px * 0.08);
              c.strokeStyle = o.stroke;
              c.lineJoin = 'round';
              c.strokeText(o.text, 0, 0);
            }
            c.fillStyle = o.fill;
            c.fillText(o.text, 0, 0);
          }
          c.restore();
        });
      }

      /* Dashed bounding box, four corner grips, and the yellow rotate dial. */
      paintChrome(c) {
        var o = this.active;
        var pts = this.corners(o);
        c.save();
        c.strokeStyle = '#111';
        c.lineWidth = 1.5;
        c.setLineDash([5, 4]);
        c.beginPath();
        pts.forEach((p, i) => (i ? c.lineTo(p.x, p.y) : c.moveTo(p.x, p.y)));
        c.closePath();
        c.stroke();
        c.setLineDash([]);

        pts.forEach((p) => {
          c.fillStyle = '#fff';
          c.strokeStyle = '#111';
          c.lineWidth = 1.5;
          c.beginPath();
          c.rect(p.x - CORNER, p.y - CORNER, CORNER * 2, CORNER * 2);
          c.fill();
          c.stroke();
        });

        var r = this.rotHandle(o);
        c.fillStyle = getComputedStyle(this).getPropertyValue('--eume-accent').trim() || '#edb230';
        c.beginPath();
        c.arc(r.x, r.y, ROT_R, 0, Math.PI * 2);
        c.fill();
        c.strokeStyle = '#111';
        c.lineWidth = 1.6;
        c.lineCap = 'round';
        c.beginPath();
        c.arc(r.x, r.y, 6.5, -0.6, Math.PI * 1.4);
        c.stroke();
        c.beginPath();
        c.moveTo(r.x + 3.5, r.y - 7.5);
        c.lineTo(r.x + 7.5, r.y - 5.5);
        c.lineTo(r.x + 4.5, r.y - 2.5);
        c.stroke();
        c.restore();
      }

      /* Flag anything crossing the print boundary, and place the red tag on it. */
      checkOutside() {
        var tag = this.q('[data-outside]');
        var worst = null;
        this.objects.forEach((o) => {
          if (!o.visible) return;
          var pts = this.corners(o);
          var out = pts.some((p) => p.x < -0.5 || p.y < -0.5 || p.x > this.W + 0.5 || p.y > this.H + 0.5);
          if (out && !worst) worst = pts;
        });
        this.print.classList.toggle('is-out', !!worst);
        if (!worst) {
          tag.hidden = true;
          return;
        }
        var minX = Math.min.apply(null, worst.map((p) => p.x));
        var minY = Math.min.apply(null, worst.map((p) => p.y));
        tag.hidden = false;
        tag.style.left = Math.max(0, Math.min(minX, this.W - 120)) + 'px';
        tag.style.top = Math.max(18, minY) + 'px';
      }

      /* ------------------------------------------------- pointer interaction */

      bindCanvas() {
        var cv = this.canvas;
        if (!cv) return;
        var pos = (e) => {
          var r = cv.getBoundingClientRect();
          return { x: e.clientX - r.left, y: e.clientY - r.top };
        };

        cv.addEventListener('pointerdown', (e) => {
          var p = pos(e);
          cv.setPointerCapture(e.pointerId);

          if (this.active) {
            var rot = this.rotHandle(this.active);
            if (dist(p, rot) <= ROT_R + 6) {
              this.drag = { mode: 'rotate', o: this.active, off: this.angleTo(p, this.active) - this.active.angle };
              return;
            }
            var cs = this.corners(this.active);
            for (var i = 0; i < 4; i += 1) {
              if (near(p, cs[i], GRAB)) {
                var o = this.active;
                this.drag = {
                  mode: 'scale',
                  o: o,
                  d0: Math.max(dist(p, { x: o.x * this.W, y: o.y * this.H }), 1),
                  v0: o.type === 'image' ? o.w : o.size,
                };
                return;
              }
            }
          }

          var hit = this.hitTest(p);
          this.active = hit;
          if (hit) {
            this.drag = { mode: 'move', o: hit, dx: p.x - hit.x * this.W, dy: p.y - hit.y * this.H };
            if (hit.type === 'text') this.syncText(hit);
          }
          this.render();
          this.refresh();
        });

        cv.addEventListener('pointermove', (e) => {
          if (!this.drag) return;
          var p = pos(e);
          var d = this.drag;
          if (d.mode === 'move') {
            d.o.x = clamp((p.x - d.dx) / this.W, -0.4, 1.4);
            d.o.y = clamp((p.y - d.dy) / this.H, -0.4, 1.4);
          } else if (d.mode === 'rotate') {
            d.o.angle = this.angleTo(p, d.o) - d.off;
          } else {
            var f = clamp(dist(p, { x: d.o.x * this.W, y: d.o.y * this.H }) / d.d0, 0.1, 12);
            if (d.o.type === 'image') d.o.w = this.fitToFrame(d.o, clamp(d.v0 * f, 0.03, 4));
            else d.o.size = this.fitToFrame(d.o, clamp(d.v0 * f, this.minTextSize(), this.maxTextSize()));
          }
          this.render();
        });

        var end = () => {
          if (!this.drag) return;
          this.drag = null;
          this.push();
          this.refresh();
        };
        cv.addEventListener('pointerup', end);
        cv.addEventListener('pointercancel', end);

        document.addEventListener('keydown', (e) => {
          if (this.view !== 'editor' || !this.active) return;
          var el = document.activeElement;
          if (el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) return;
          if (e.key === 'Delete' || e.key === 'Backspace') {
            e.preventDefault();
            return this.remove(this.active);
          }
          var n = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
          if (!n) return;
          e.preventDefault();
          var step = e.shiftKey ? 10 : 1;
          this.active.x += (n[0] * step) / this.W;
          this.active.y += (n[1] * step) / this.H;
          this.render();
        });
      }

      angleTo(p, o) {
        return Math.atan2(p.y - o.y * this.H, p.x - o.x * this.W);
      }

      hitTest(p) {
        for (var i = this.objects.length - 1; i >= 0; i -= 1) {
          var o = this.objects[i];
          if (!o.visible) continue;
          var s = this.size(o);
          var l = this.toLocal(p.x, p.y, o);
          if (Math.abs(l.x) <= s.w / 2 && Math.abs(l.y) <= s.h / 2) return o;
        }
        return null;
      }

      /* -------------------------------------------------------- editor wiring */

      bindEditor() {
        this.panel = this.q('[data-panel]');
        this.textHint = (this.q('[data-hint]') || {}).textContent || '';
        this.textHint = this.textHint.trim();

        this.qa('[data-tab]').forEach((b) => b.addEventListener('click', () => this.setTab(b.dataset.tab)));
        this.on('[data-open-sheet]', 'click', () => this.openSheet('tools'));
        this.on('[data-sheet-close]', 'click', () => this.panel.classList.remove('is-open'));
        this.on('[data-sheet-back]', 'click', () => this.setTab('tools'));
        this.on('[data-foot-next]', 'click', () => this.advance());

        var input = this.q('[data-text-input]');
        if (input) input.addEventListener('input', () => {
          this.set('[data-text-count]', 'textContent', input.value.length + '/' + this.cfg.textMax);
          if (this.active && this.active.type === 'text') {
            this.active.text = input.value;
            this.active.size = this.fitToFrame(this.active, this.active.size);
            this.render();
          }
          this.paintAa();
        });
        this.on('[data-add-text]', 'click', () => this.addText());
        this.on('[data-font-search]', 'input', (e) => this.drawFonts(e.target.value));
        this.on('[data-font-search]', 'focus', () => this.drawFonts(this.q('[data-font-search]').value));

        ['fill', 'stroke'].forEach((key) => {
          var picker = this.q('[data-colour="' + key + '"]');
          var hex = this.q('[data-hex="' + key + '"]');
          var hue = this.q('[data-hue="' + key + '"]');
          if (!picker || !hex || !hue) return;
          picker.addEventListener('input', () => this.setColour(key, picker.value));
          hue.addEventListener('input', () => this.setColour(key, hslToHex(Number(hue.value), 96, 50)));
          hex.addEventListener('change', () => {
            if (/^#[0-9a-f]{6}$/i.test(hex.value)) this.setColour(key, hex.value);
            else hex.value = picker.value.toUpperCase();
          });
        });

        var file = this.q('[data-file]');
        if (file) {
          file.addEventListener('change', (e) => {
            this.addImages(e.target.files);
            e.target.value = '';
          });
          this.on('[data-add-more]', 'click', () => file.click());
        }
        var drop = this.q('[data-drop]');
        if (drop) ['dragover', 'dragleave', 'drop'].forEach((t) =>
          drop.addEventListener(t, (e) => {
            e.preventDefault();
            drop.classList.toggle('is-over', t === 'dragover');
            if (t === 'drop') this.addImages(e.dataTransfer.files);
          })
        );

        this.on('[data-undo]', 'click', () => this.undo());
        this.on('[data-redo]', 'click', () => this.redo());
        this.on('[data-reset]', 'click', () => this.reset());

        var dField = this.q('[data-design-field]') || document.createElement('input');
        this.on('[data-design-toggle]', 'change', (e) => {
          if (e.target.checked) this.openEngraving('design');
          else this.clearTag('design');
        });
        dField.addEventListener('input', () => {
          this.set('[data-design-count]', 'textContent', dField.value.length + '/' + this.cfg.engraving.max);
        });
        dField.addEventListener('change', () => this.saveTag('design', dField.value));
        this.on('[data-design-edit]', 'click', () => this.openEngraving('design'));
        this.on('[data-design-remove]', 'click', () => this.clearTag('design'));

        this.on('[data-to-summary]', 'click', () => this.setTab('summary'));
        this.on('[data-edit-design]', 'click', () => this.setTab('text'));
        this.on('[data-confirm]', 'change', () => this.updateStock());
        this.on('[data-design-atc]', 'click', () => this.addDesign());
      }

      openSheet(tab) {
        this.setTab(tab);
        this.panel.classList.add('is-open');
      }

      setTab(name, quiet) {
        this.tab = name;
        this.qa('[data-pane]').forEach((p) => (p.hidden = p.dataset.pane !== name));
        this.qa('.eume-tabs [data-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.tab === name)));
        var step = name === 'summary' ? 'preview' : name;
        this.qa('[data-step]').forEach((li) => li.classList.toggle('is-on', li.dataset.step === step));
        this.set('[data-sheet-title]', 'textContent', TITLES[name] || 'Tools');
        var backBtn = this.q('[data-sheet-back]');
        if (backBtn) backBtn.style.visibility = name === 'tools' ? 'hidden' : 'visible';
        this.set('[data-editor-foot]', 'hidden', name === 'tools' || name === 'summary');
        this.set('[data-hint]', 'textContent', this.hintFor(name));
        if (name === 'preview' || name === 'summary') this.summary();
        if (name === 'layers') this.drawLayers();
        if (!quiet && !this.isDesktop()) this.panel.classList.add('is-open');
      }

      hintFor(name) {
        if (name === 'images') return 'Upload a high-quality image. Use clear, high-resolution images for the best results.';
        if (name === 'tools' || name === 'layers') return 'Add text, initials or images to personalise your luggage.';
        return this.textHint;
      }

      advance() {
        var order = ['text', 'images', 'preview', 'summary'];
        var i = order.indexOf(this.tab);
        this.setTab(order[Math.min(i + 1, order.length - 1)]);
      }

      /* --------------------------------------------------------------- fonts */

      loadFont(family) {
        var id = 'eume-font-' + family.replace(/\s+/g, '-').toLowerCase();
        if (document.getElementById(id)) return;
        var link = document.createElement('link');
        link.id = id;
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(family).replace(/%20/g, '+') + ':wght@400;600;700&display=swap';
        document.head.appendChild(link);
        if (document.fonts && document.fonts.load) {
          document.fonts.load('600 40px "' + family + '"').then(() => this.render()).catch(() => {});
        }
      }

      drawFonts(query) {
        var list = this.q('[data-font-list]');
        if (!list) return;
        var matches = this.fonts.filter((f) => f.toLowerCase().indexOf(String(query).toLowerCase()) !== -1);
        list.hidden = matches.length === 0;
        list.innerHTML = '';
        matches.forEach((f) => {
          var li = document.createElement('li');
          li.setAttribute('aria-selected', String(f === this.font));
          li.innerHTML =
            '<span style="font-family:\'' + f + '\',sans-serif">Aa</span>' +
            '<span style="font-family:\'' + f + '\',sans-serif">' + esc(f) + '</span>';
          li.addEventListener('click', () => {
            this.font = f;
            this.drawFonts(query);
            this.paintAa();
            if (this.active && this.active.type === 'text') {
              this.active.font = f;
              this.render();
              this.push();
            }
          });
          list.appendChild(li);
        });
      }

      /* The Aa tile previews the exact styling the next text will get. */
      paintAa() {
        var aa = this.q('[data-aa]');
        var fillEl = this.q('[data-colour="fill"]');
        var strokeEl = this.q('[data-colour="stroke"]');
        if (!aa || !fillEl || !strokeEl) return;
        var fill = fillEl.value;
        var stroke = strokeEl.value;
        aa.style.fontFamily = "'" + this.font + "', sans-serif";
        aa.style.color = fill;
        aa.style.webkitTextStroke = stroke.toLowerCase() === fill.toLowerCase() ? '' : '2px ' + stroke;
        aa.style.paintOrder = 'stroke fill';
      }

      setColour(key, hex) {
        this.set('[data-colour="' + key + '"]', 'value', hex);
        this.set('[data-hex="' + key + '"]', 'value', hex.toUpperCase());
        if (this.active && this.active.type === 'text') {
          if (key === 'fill') this.active.fill = hex;
          else {
            this.active.stroke = hex;
          }
          this.render();
          this.push();
        }
        this.paintAa();
      }

      syncText(o) {
        this.set('[data-text-input]', 'value', o.text);
        this.set('[data-text-count]', 'textContent', o.text.length + '/' + this.cfg.textMax);
        this.set('[data-colour="fill"]', 'value', o.fill);
        this.set('[data-hex="fill"]', 'value', o.fill.toUpperCase());
        this.set('[data-colour="stroke"]', 'value', o.stroke);
        this.set('[data-hex="stroke"]', 'value', o.stroke.toUpperCase());
        this.font = o.font;
        this.drawFonts(this.q('[data-font-search]').value);
        this.paintAa();
      }

      /* -------------------------------------------------------------- objects */

      addText() {
        var input = this.q('[data-text-input]');
        var text = input.value.trim();
        if (!text) {
          input.focus();
          return this.say('Enter some text first.', true);
        }
        var o = {
          type: 'text',
          text: text,
          font: this.font,
          fill: this.q('[data-colour="fill"]').value,
          stroke: this.q('[data-colour="stroke"]').value,
          size: 0.2,
          x: 0.5,
          y: 0.5,
          angle: 0,
          visible: true,
        };
        o.size = this.startSizeFor(o);
        this.objects.push(o);
        this.active = o;
        input.value = '';
        this.set('[data-text-count]', 'textContent', '0/' + this.cfg.textMax);
        this.render();
        this.push();
        this.refresh();
        this.say('Text added. Drag to move, corners to resize, the yellow dial to rotate.');
      }

      addImages(files) {
        var limit = Number(this.cfg.maxImages) || 2;
        Array.prototype.slice.call(files).forEach((f) => {
          if (!/^image\//.test(f.type)) return;
          if (this.objects.filter((o) => o.type === 'image').length >= limit) {
            return this.say('You can add up to ' + limit + ' image' + (limit === 1 ? '' : 's') + '.', true);
          }
          if (f.size > 10 * 1024 * 1024) return this.say(f.name + ' is larger than 10 MB.', true);
          var reader = new FileReader();
          reader.onload = () => this.placeImage(reader.result, f.name);
          reader.readAsDataURL(f);
        });
      }

      placeImage(src, name) {
        var limit = Number(this.cfg.maxImages) || 2;
        var img = new Image();
        img.onload = () => {
          if (this.objects.filter((o) => o.type === 'image').length >= limit) {
            return this.say('You can add up to ' + limit + ' image' + (limit === 1 ? '' : 's') + '.', true);
          }
          var o = {
            type: 'image',
            name: name,
            src: src,
            img: img,
            natW: img.naturalWidth,
            natH: img.naturalHeight,
            w: 0.42,
            x: 0.5,
            y: 0.5,
            angle: 0,
            visible: true,
          };
          o.w = this.startSizeFor(o);
          this.objects.push(o);
          this.active = o;
          this.render();
          this.push();
          this.refresh();
        };
        img.onerror = () => this.say('That image could not be read.', true);
        img.src = src;
      }

      remove(o) {
        this.objects = this.objects.filter((x) => x !== o);
        if (this.active === o) this.active = null;
        this.render();
        this.push();
        this.refresh();
      }

      /* ---------------------------------------------------------------- lists */

      refresh() {
        this.drawImages();
        this.drawLayers();
        var n = this.objects.length;
        this.set('[data-foot-count]', 'textContent', n + (n === 1 ? ' Element' : ' Elements') + ' \u00b7 ' + this.money(this.total()) + ' Total');
        this.set('[data-foot-incl]', 'textContent', this.fee() ? 'Incl. ' + this.money(this.fee()) : '');
        this.set('[data-layer-empty]', 'hidden', n > 0);
        this.set('[data-reset]', 'disabled', n === 0);
        this.updateStock();
      }

      drawImages() {
        var list = this.q('[data-image-list]');
        if (!list) return;
        list.innerHTML = '';
        this.objects.filter((o) => o.type === 'image').forEach((o) => list.appendChild(this.row(o, false)));
      }

      drawLayers() {
        var list = this.q('[data-layer-list]');
        if (!list) return;
        list.innerHTML = '';
        this.objects.slice().reverse().forEach((o) => list.appendChild(this.row(o, true)));
      }

      row(o, drag) {
        var li = document.createElement('li');
        li.className = 'eume-row' + (this.active === o ? ' is-on' : '');
        if (drag) li.draggable = true;

        var isText = o.type === 'text';
        var low = !isText && Math.min(o.natW, o.natH) < MIN_PRINT_PX;
        var sub = isText ? o.font : o.natW + '\u00d7' + o.natH + ' \u00b7 ' + (low ? 'low resolution' : 'good for print');

        li.innerHTML =
          '<span class="eume-row__grip">' + (drag ? ico('grip') : '') + '</span>' +
          '<span class="eume-row__thumb">' + (isText ? 'T' : '<img src="' + o.src + '" alt="">') + '</span>' +
          '<span><span class="eume-row__name">' + esc(isText ? o.text : o.name) + '</span>' +
          '<span class="eume-row__sub' + (low ? ' is-low' : '') + '">' + esc(sub) + '</span></span>' +
          '<button type="button" data-vis aria-label="Toggle visibility">' + ico(o.visible ? 'eye' : 'eyeOff') + '</button>' +
          '<button type="button" class="eume-danger" data-del aria-label="Delete">' + ico('trash') + '</button>';

        li.addEventListener('click', (e) => {
          if (e.target.closest('button')) return;
          this.active = o;
          if (isText) this.syncText(o);
          this.render();
          this.refresh();
        });
        li.querySelector('[data-vis]').addEventListener('click', () => {
          o.visible = !o.visible;
          this.render();
          this.push();
          this.refresh();
        });
        li.querySelector('[data-del]').addEventListener('click', () => this.remove(o));

        if (drag) {
          li.addEventListener('dragstart', () => {
            this.dragRow = o;
            li.classList.add('is-drag');
          });
          li.addEventListener('dragend', () => li.classList.remove('is-drag'));
          li.addEventListener('dragover', (e) => e.preventDefault());
          li.addEventListener('drop', (e) => {
            e.preventDefault();
            if (!this.dragRow || this.dragRow === o) return;
            var from = this.objects.indexOf(this.dragRow);
            var to = this.objects.indexOf(o);
            this.objects.splice(to, 0, this.objects.splice(from, 1)[0]);
            this.dragRow = null;
            this.render();
            this.push();
            this.refresh();
          });
        }
        return li;
      }

      /* -------------------------------------------------------------- history */

      snapshot() {
        return JSON.stringify(
          this.objects.map((o) => {
            var c = Object.assign({}, o);
            delete c.img;
            return c;
          })
        );
      }

      push() {
        var snap = this.snapshot();
        if (this.history[this.hIndex] === snap) return;
        this.history = this.history.slice(0, this.hIndex + 1);
        this.history.push(snap);
        if (this.history.length > 50) this.history.shift();
        this.hIndex = this.history.length - 1;
        this.buttons();
      }

      restore(i) {
        this.hIndex = i;
        this.objects = JSON.parse(this.history[i]).map((o) => {
          if (o.type === 'image') {
            var img = new Image();
            img.onload = () => this.render();
            img.src = o.src;
            o.img = img;
          }
          return o;
        });
        this.active = null;
        this.render();
        this.refresh();
        this.buttons();
      }

      undo() {
        if (this.hIndex > 0) this.restore(this.hIndex - 1);
      }

      redo() {
        if (this.hIndex < this.history.length - 1) this.restore(this.hIndex + 1);
      }

      reset() {
        if (!this.objects.length) return;
        if (!window.confirm('Remove everything and start again?')) return;
        this.objects = [];
        this.active = null;
        this.render();
        this.push();
        this.refresh();
        this.say('Design cleared.');
      }

      buttons() {
        this.set('[data-undo]', 'disabled', this.hIndex <= 0);
        this.set('[data-redo]', 'disabled', this.hIndex >= this.history.length - 1);
      }

      /* -------------------------------------------------------------- summary */

      counts() {
        return {
          text: this.objects.filter((o) => o.type === 'text').length,
          images: this.objects.filter((o) => o.type === 'image').length,
        };
      }

      fee() {
        if (!this.cfg.fee.variantId || this.cfg.fee.available === false) return 0;
        return Number(this.cfg.fee.amount) || 0;
      }

      total() {
        return (this.body ? this.body.price : 0) + this.fee();
      }

      summary() {
        if (!this.body) return;
        var c = this.counts();
        this.set('[data-count-text]', 'textContent', c.text + (c.text === 1 ? ' text' : ' text'));
        this.set('[data-count-images]', 'textContent', c.images + (c.images === 1 ? ' image' : ' images'));
        this.set('[data-price-total]', 'textContent', this.money(this.total()));
        this.set('[data-price-break]', 'textContent', this.fee()
          ? this.money(this.body.price) + '  + ' + this.money(this.fee()) + ' ' + this.cfg.fee.label
          : '');

        var rows = [['Product', this.cfg.product.title]];
        // A single-variant product has no real colour choice, so skip that row.
        if (this.cfg.product.variants.length > 1) rows.push(['Body colour', this.body.title]);
        rows.push(['Customisation', 'Design your own']);
        rows.push(['Your design', c.text + ' text \u00b7 ' + c.images + ' images']);
        rows.push(['Product price', this.money(this.body.price)]);
        if (this.fee()) rows.push([this.cfg.fee.label, this.money(this.fee())]);
        if (this.designTag) rows.push(['Personalisation tag', this.designTag]);
        if (this.cfg.productionTime) rows.push(['Production time', this.cfg.productionTime]);

        this.set('[data-summary]', 'innerHTML',
          '<h3>' + esc(this.cfg.product.title) + ' \u2013 Personalised</h3><dl>' +
          rows.map((r) => '<dt>' + esc(r[0]) + '</dt><dd>' + esc(String(r[1])) + '</dd>').join('') +
          '<dt class="is-total">Total</dt><dd class="is-total">' + this.money(this.total()) + '</dd></dl>');
        this.refresh();
      }

      /* --------------------------------------------------------------- export */

      artwork() {
        if (!this.ctx) return null;
        var off = document.createElement('canvas');
        var scale = EXPORT_W / this.W;
        off.width = Math.round(this.W * scale);
        off.height = Math.round(this.H * scale);
        var c = off.getContext('2d');
        c.setTransform(scale, 0, 0, scale, 0, 0);
        this.paint(c, this.W, this.H);
        return toFile(off.toDataURL('image/png'), 'eume-artwork.png');
      }

      mockup() {
        if (!this.base || !this.base.naturalWidth) return null;
        try {
          var a = this.cfg.printArea;
          var w = this.base.naturalWidth;
          var h = this.base.naturalHeight;
          var off = document.createElement('canvas');
          off.width = w;
          off.height = h;
          var c = off.getContext('2d');
          c.drawImage(this.base, 0, 0, w, h);
          var sub = this.subject || { x: 0, y: 0, w: 1, h: 1 };
          var sx = w * sub.x;
          var sy = h * sub.y;
          var sw2 = w * sub.w;
          var sh2 = h * sub.h;
          c.save();
          c.translate(sx + (sw2 * a.left) / 100, sy + (sh2 * a.top) / 100);
          var pw = (sw2 * a.width) / 100;
          c.scale(pw / this.W, pw / this.W);
          this.paint(c, this.W, this.H);
          c.restore();
          return toFile(off.toDataURL('image/png'), 'eume-preview.png');
        } catch (e) {
          return null; // photo tainted the canvas; artwork still ships
        }
      }

      /* ----------------------------------------------------------- add to cart */

      async addDesign() {
        if (this.busy) return;
        if (!this.objects.length) return this.say('Add some text or an image before adding to cart.', true);
        if (!this.body || !this.body.available) return this.say('That colour is out of stock.', true);
        var btn = this.q('[data-design-atc]');
        this.busy = true;
        btn.disabled = true;
        this.say('Preparing your design\u2026');

        var wasActive = this.active;
        this.active = null;
        this.render(); // keep handles out of the exported files

        try {
          var art = this.artwork();
          var mock = this.mockup();
          var c = this.counts();

          var form = new FormData();
          form.append('id', String(this.body.id));
          form.append('quantity', '1');
          form.append('properties[' + this.cfg.designProperty + ']', art, art.name);
          if (mock) form.append('properties[Preview]', mock, mock.name);
          form.append('properties[Body colour]', this.body.title);
          form.append('properties[Your design]', c.text + ' text, ' + c.images + ' images');
          var key = '';
          if (this.designTag) {
            key = Date.now() + '_' + this.body.id;
            form.append('properties[' + this.cfg.engraving.property + ']', this.designTag);
            form.append('properties[_Personalisation]', 'Yes');
            form.append('properties[_BundleKey]', key);
          }
          if (this.cfg.productionTime) form.append('properties[Production time]', this.cfg.productionTime);
          form.append('properties[_design_state]', this.snapshot().slice(0, 40000));

          var res = await fetch(this.cfg.cartAddUrl, { method: 'POST', headers: { Accept: 'application/javascript' }, body: form });
          if (!res.ok) {
            var err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'That could not be added to the cart.');
          }

          if (this.designTag && this.cfg.engraving.freebieId) {
            var fb = { _Freebie: 'Yes', _BundleKey: key };
            fb[this.cfg.engraving.property] = this.designTag;
            await this.cartAdd([{ id: Number(this.cfg.engraving.freebieId), quantity: 1, properties: fb }]);
          }
          if (this.fee()) {
            await this.cartAdd([{ id: Number(this.cfg.fee.variantId), quantity: 1, properties: { _for: this.cfg.product.title } }]);
          }
          window.location.href = this.cfg.cartUrl;
        } catch (err) {
          this.active = wasActive;
          this.render();
          this.say(err.message, true);
          btn.disabled = false;
        } finally {
          this.busy = false;
        }
      }

      async cartAdd(items) {
        var res = await fetch(this.cfg.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (!res.ok) {
          var err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'That could not be added to the cart.');
        }
        return res.json();
      }

      /* --------------------------------------------------------------- helpers */

      money(cents) {
        var n = (Number(cents) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
        return String(this.cfg.moneyFormat).replace(/\{\{\s*[a-z_]+\s*\}\}/i, n);
      }

      say(msg, isError) {
        var el = this.q('[data-status]');
        if (!el) return;
        el.textContent = msg;
        el.classList.toggle('is-error', !!isError);
        clearTimeout(this.timer);
        this.timer = setTimeout(() => (el.textContent = ''), 5000);
      }
    }

    /* Find the non-background bounds of an image, as fractions of its size.
       Product photos carry a lot of white padding, so a print area expressed as
       a percentage of the whole file lands in the wrong place. Measuring the
       subject first makes the percentages mean "of the luggage". */
    function subjectBox(data, w, h) {
      var minX = w, minY = h, maxX = -1, maxY = -1;
      for (var y = 0; y < h; y += 1) {
        for (var x = 0; x < w; x += 1) {
          var i = (y * w + x) * 4;
          var alpha = data[i + 3];
          if (alpha < 12) continue; // transparent padding
          if (data[i] > 247 && data[i + 1] > 247 && data[i + 2] > 247) continue; // white padding
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
      if (maxX < 0) return { x: 0, y: 0, w: 1, h: 1 };
      return {
        x: minX / w,
        y: minY / h,
        w: (maxX - minX + 1) / w,
        h: (maxY - minY + 1) / h,
      };
    }

    function clamp(v, lo, hi) {
      return Math.min(hi, Math.max(lo, v));
    }

    function dist(a, b) {
      return Math.hypot(a.x - b.x, a.y - b.y);
    }

    function near(p, q, r) {
      return Math.abs(p.x - q.x) <= r && Math.abs(p.y - q.y) <= r;
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function hslToHex(h, s, l) {
      var a = (s / 100) * Math.min(l / 100, 1 - l / 100);
      function f(n) {
        var k = (n + h / 30) % 12;
        var v = l / 100 - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
        return Math.round(255 * v).toString(16).padStart(2, '0');
      }
      return '#' + f(0) + f(8) + f(4);
    }

    function toFile(dataUrl, name) {
      var parts = dataUrl.split(',');
      var mime = parts[0].match(/:(.*?);/)[1];
      var bin = atob(parts[1]);
      var bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
      return new File([bytes], name, { type: mime });
    }

    function ico(kind) {
      var paths = {
        eye: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
        eyeOff: '<path d="M10.6 5.2A9.9 9.9 0 0 1 12 5c6.4 0 10 7 10 7a18 18 0 0 1-3.1 4M6.2 6.2A18 18 0 0 0 2 12s3.6 7 10 7a9.8 9.8 0 0 0 5-1.3"/><path d="m3 3 18 18"/>',
        trash: '<path d="M4 7h16M10 11v6M14 11v6"/><path d="m6 7 1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>',
        grip: '<circle cx="9" cy="6" r="1.3"/><circle cx="9" cy="12" r="1.3"/><circle cx="9" cy="18" r="1.3"/><circle cx="15" cy="6" r="1.3"/><circle cx="15" cy="12" r="1.3"/><circle cx="15" cy="18" r="1.3"/>',
      };
      return '<svg viewBox="0 0 24 24" class="eume-ico">' + paths[kind] + '</svg>';
    }

    if (!customElements.get('eume-customiser')) customElements.define('eume-customiser', Eume);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
